import { gql } from "@apollo/client";
import { AccountFragment } from "fragments/account";

// What the renderer serves, read here by the page editor's preview and by the
// pickers. Read-only: publishing is a verb on the draft (queries/blog-post).
export const BlogPublishedFragment = gql`
  fragment BlogPublishedFragment on BlogPublished {
    id
    postId
    slug
    title
    abstract
    image
    tags
    authorId
    date
    content
    publishedAt
    createdAt
    updatedAt
  }
`;

export const get = gql`
  query BlogPublishedGet($siteId: String!, $postId: String!) {
    viewer {
      id
      account {
        ...AccountFragment
        sites {
          id
          get(siteId: $siteId) {
            id
            blog {
              id
              published {
                id
                get(postId: $postId) {
                  ...BlogPublishedFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${BlogPublishedFragment}
`;

export const bySlug = gql`
  query BlogPublishedBySlug($siteId: String!, $slug: String!) {
    viewer {
      id
      account {
        ...AccountFragment
        sites {
          id
          get(siteId: $siteId) {
            id
            blog {
              id
              published {
                id
                bySlug(slug: $slug) {
                  ...BlogPublishedFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${BlogPublishedFragment}
`;

// One page of the public listing, by number — the same read the served page
// makes, so the preview shows the page a visitor would get.
export const page = gql`
  query BlogPublishedPage($siteId: String!, $input: BlogPublishedPageInput) {
    viewer {
      id
      account {
        ...AccountFragment
        sites {
          id
          get(siteId: $siteId) {
            id
            blog {
              id
              published {
                id
                list(input: $input) {
                  id
                  page
                  limit
                  tag
                  hasPrev
                  hasNext
                  items {
                    ...BlogPublishedFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${BlogPublishedFragment}
`;
